import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import HeroImg from "../../../assets/images/hero/hero-2.png";
import OutlinedButton from "../../../components/button/OutlinedButton";
import H1 from "../../../components/typography/H1";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  z-index: 1;
  opacity: 1;
  transition: opacity 0.4s ease-in-out;
`;

const Wrapper = styled.div`
  width: 100%;
  height: inherit;
  position: relative;
  cursor: pointer;
  &:hover {
    ${Overlay} {
      opacity: 0.6;
    }
    button {
      background-color: ${colors.backgroundPrimary};
      transition-duration: 0.6s;
      color: ${colors.textPrimary};
    }
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;

  img {
    width: 100%;
    max-height: 700px;
    min-height: 350px;
    height: auto;
    object-fit: cover;
  }
`;

const Info = styled.div`
  position: absolute;
  bottom: 120px;
  left: 50px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 20px;
  width: 450px;
  z-index: 2;
  p {
    font-size: ${fontSize.m};
    font-weight: 300;
    margin-top: -15px;
  }
  @media (max-width: 500px) {
    width: 300px;
    bottom: 30px;
    p {
      font-size: ${fontSize.s};
    }
  }
`;

function CategoryHeroLarge() {
  const navigate = useNavigate();
  return (
    <Wrapper
      onClick={() => {
        navigate(`/products/Jacket & Outer`);
      }}
    >
      <Container>
        <img src={HeroImg} alt="hero" />
        <Overlay />
        <Info style={{ color: colors.backgroundPrimary }}>
          <H1>Jackets & Coats</H1>
          <p>
            Wallet Mens Wear has a long history of creating best-selling coats,
            built on fresh designs and timeless quality.
          </p>
          <OutlinedButton text={"Shop Now"} style={{ width: "140px" }} />
        </Info>
      </Container>
    </Wrapper>
  );
}

export default CategoryHeroLarge;
